import { useCallback, useRef, useState } from 'react';
import { useQuery } from 'react-query';

import {
  SHOW_CONFIRMATION_MODAL_KEY,
  ShowConfirmationModalResponse,
  showConfirmationModal,
} from '@utils/backend-api/showConfirmationModal';

export function useShowConfirmationModalQuery(retry: number | boolean = 3) {
  const { data, isLoading } = useQuery<ShowConfirmationModalResponse>(
    SHOW_CONFIRMATION_MODAL_KEY,
    () => showConfirmationModal(),
    {
      initialData: null,
      retry,
    }
  );

  return { ...data, isLoadingShowConfirmationModal: isLoading };
}

export default function useShowConfirmationModal() {
  const {
    billingCycle,
    nextBillingAmountWithTax,
    nextBillingDate,
    showConfirmationModal,
    subscriptionPlan,
  } = useShowConfirmationModalQuery();
  const [openConfirmationModal, setOpenConfirmationModal] = useState<boolean>(false);
  const hasModalOpened = useRef<boolean>(false);

  const checkForConfirmationModal = useCallback(() => {
    if (!showConfirmationModal || hasModalOpened.current) return;

    setOpenConfirmationModal(true);
    hasModalOpened.current = true;
  }, [setOpenConfirmationModal, showConfirmationModal]);

  return {
    billingCycle,
    checkForConfirmationModal,
    nextBillingAmountWithTax,
    nextBillingDate,
    openConfirmationModal,
    setOpenConfirmationModal,
    subscriptionPlan,
  };
}
